import React from "react";
import { HeaderButtonsPC } from "../../../Header/loader";
import { HeaderLinksPC } from "../../../Header/HeaderLinksPC";
import { LanguagesMenu } from "../../../../components/LanguageSwitcher/loader";
import { OddsPC } from "../../../../components/Odds";
import {
  ControlCenterComponentType,
  ControlCenterFactory
} from "../../../../components/ControlCenter";
import { links } from "./Config.resource";
import { SettingsPC } from "../../../../components/Settings/loader";
import { AppFeatures } from "../../../../constants/featureFlags";
import { useFeature } from "../../../../hooks/useFeature";
import { CrossActivity } from "../../../CrossActivity/loader";
import { HeaderRightCTA } from "../../../Header/HeaderWrapper";
import { useSelector } from "react-redux";
import { UserContextSelectors } from "../../../../redux/selectors";
import DepositLimitsHeaderButton from "../../../Header/DepositLimitsHeaderButton";
import { DepositLimitsHeaderButtonPCWrapper } from "../../../Header/DepositLimitsHeaderButtonPCWrapper";

const HeaderPC = () => {
  const isSettingsDrawerEnabled = useFeature(AppFeatures.SETTINGS_DRAWER);
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const userCountry = useSelector(UserContextSelectors.userCountry);

  return (
    <HeaderRightCTA>
      <CrossActivity />
      <ControlCenterFactory
        componentType={ControlCenterComponentType.HeaderButton}
      />
      {!isSettingsDrawerEnabled ? (
        <>
          <OddsPC />
          <LanguagesMenu />
        </>
      ) : (
        <>
          {isAuthenticated && userCountry?.toUpperCase() === "GBR" && (
            <>
              <DepositLimitsHeaderButtonPCWrapper>
                <DepositLimitsHeaderButton dataLabel="uc-depositLimit-pc-open" />
              </DepositLimitsHeaderButtonPCWrapper>
            </>
          )}
          <SettingsPC />
        </>
      )}
      <HeaderLinksPC helpLink={links.help} />
      <HeaderButtonsPC />
    </HeaderRightCTA>
  );
};

export default React.memo(HeaderPC);
